module.exports = __webpack_public_path__ + "img/robot_foot.a5ebdb1f.png";